export const ADD_TASK_REQUEST = "ADD_TASK_REQUEST";
export const ADD_TASK_SUCCESS = "ADD_TASK_SUCCESS";
export const ADD_TASK_FAILURE = "ADD_TASK_FAILURE";

export const EDIT_TASK_REQUEST = "EDIT_TASK_REQUEST";
export const EDIT_TASK_SUCCESS = "EDIT_TASK_SUCCESS";
export const EDIT_TASK_FAILURE = "EDIT_TASK_FAILURE";

export const MOVE_TASK_REQUEST = "MOVE_TASK_REQUEST";
export const MOVE_TASK_SUCCESS = "MOVE_TASK_SUCCESS";
export const MOVE_TASK_FAILURE = "MOVE_TASK_FAILURE";

export const DELETE_TASK_REQUEST = "DELETE_TASK_REQUEST";
export const DELETE_TASK_SUCCESS = "DELETE_TASK_SUCCESS";
export const DELETE_TASK_FAILURE = "DELETE_TASK_FAILURE";

export const ASSIGN_MEMBERS_TASK_REQUEST = "ASSIGN_MEMBERS_TASK_REQUEST";
export const ASSIGN_MEMBERS_TASK_SUCCESS = "ASSIGN_MEMBERS_TASK_SUCCESS";
export const ASSIGN_MEMBERS_TASK_FAILURE = "ASSIGN_MEMBERS_TASK_FAILURE";

export const SET_TASK = "SET_TASK";
